import { fashion, dark } from "@mochi/themes/settingThemes";

const select = 0;
const typeTheme = [fashion, dark];
export const theme = typeTheme[select];
